'use strict';
angular.module('schoolLinqApp').factory('fm1099Service', [
	'$http',
	function ($http) {
		var endpoint = '/api/fm1099';

		function getTaxYears() {
			return $http.get(endpoint + '/getTaxYears');
		}

		function getVendors(taxYear) {
			return $http.get(endpoint + '/getVendors', {
				params: { TaxYear: taxYear },
			});
		}

		function is1099ReadyForFinalize(taxYear) {
			return $http.get(endpoint + '/ready-for-finalize', {
				params: { taxYear: taxYear },
			});
		}

		function getVendorsForAdjustment(taxYear) {
			return $http.get(endpoint + '/getVendorsForAdjustment', {
				params: { TaxYear: taxYear },
			});
		}

		function create1099s(paramModel) {
			return $http.post(endpoint, paramModel);
		}

		function finalize1099s(taxYear) {
			return $http.post(endpoint + '/finalize', taxYear);
		}

		function save1099Adjustments(paramModel) {
			return $http.post(endpoint + '/save1099Adjustments', paramModel);
		}

		function reprint1099s(paramModel) {
			return $http.post(endpoint + '/reprint-1099s', paramModel);
		}

		return {
			getTaxYears: getTaxYears,
			getVendors: getVendors,
			getVendorsForAdjustment: getVendorsForAdjustment,
			is1099ReadyForFinalize: is1099ReadyForFinalize,
			create1099s: create1099s,
			reprint1099s: reprint1099s,
			finalize1099s: finalize1099s,
			save1099Adjustments: save1099Adjustments,
		};
	},
]);
